import React, { useContext, useEffect, useState } from 'react'
import PurchaseDataTable from "./PurchaseDataTable";
import PurchaseCardExtra from "./create/PurchaseCardExtra";
import { PurchaseContext } from "../../context/PurchaseContext";
import { purchaseFilter } from "../../services/servicePurchase";
import { useLocation } from "@reach/router";
import { Card, Row } from "antd";
import "./purchase.sass"
import userDateFormatter from "../../services/formatters/userDateFormatter";
import PurchaseFilter from "./filter/PurchaseFilter";
import { SearchOutlined } from "@ant-design/icons";
import Filter from "../filterWrapper/Filter";
import config from '../../config';

const Purchase = ({navigate}) => {
    const location = useLocation();
    const { shouldUpdateTable } = useContext(PurchaseContext);
    const [updateTable] = shouldUpdateTable;
    const [dataSource, setDataSource] = useState([]);
    const [openFilter, setOpenFilter] = useState(false);
    const [filters, setFilters] = useState({
        purchaseNo: "",
        stockCode: "",
        stockName: "",
        supplierName: "",
        whom: "",
        createdBy: "",
        startDate: config.limitDates.min,
        endDate: config.limitDates.max,
        completedPurchase: null
    });
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getPurchases(page, pageSize);
    }, [location.search]);

    const baseRequestObj = {
        purchaseNo: "",
        stockCode: "",
        stockName: "",
        supplierName: "",
        whom: "",
        createdBy: "",
        startDate: config.limitDates.min,
        endDate: config.limitDates.max,
        completedPurchase: null
    };

    const resetPurchases = () => {
        setFilters(baseRequestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    };

    const getPurchases = (page, pageSize, requestObj = filters) => {
        const mockFilters = {...requestObj};
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        purchaseFilter(mockFilters)
            .then(({ data }) => {
                reducePurchaseData(data.content)
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    };
    const reducePurchaseData = (list) => {
        const purchaseData = list.map((purchase, idx) => ({
            key: `${purchase.id}-${idx}`,
            id: purchase.id,
            purchaseStatus: purchase.ps,
            purchaseNumber: purchase.pn,
            completedPurchase: purchase.cp,
            whom: purchase.whom || purchase.w,
            createdDate: userDateFormatter(purchase.cd),
            createdBy: purchase.cb,
            warehouseStatus: purchase.ws
        }))
        setDataSource(purchaseData);
    };
    const toggleFilterDisplay = () => setOpenFilter(!openFilter);

    function handleFilter({ purchaseNo, createdBy, date, supplierName, completedPurchase, stockCode, stockName, whom }) {
        const beginning = date ? date[0]._d : config.limitDates.min;
        const ending = date ? date[1]._d : config.limitDates.max;
        const requestObj = {
            purchaseNo,
            createdBy,
            supplierName,
            completedPurchase,
            stockCode,
            stockName,
            whom,
            startDate: beginning,
            endDate: ending
        };
        setFilters(requestObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
        return new Promise((resolve => resolve(200)))
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const shotTotalPaginatedItems = (total, range) => `${range[0]}-${range[1]} of ${total} items`; 

    return (
        <React.Fragment>
            <Card
                title={'Satın Alma'}
                extra={<PurchaseCardExtra />}
            >
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                </Row>
                <PurchaseDataTable tableData={dataSource} pagination={{...pagination, showTotal: shotTotalPaginatedItems, onChange: handlePaginationChange, showSizeChanger: true}} />
            </Card>
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Satın Alma'}
                    handler={handleFilter}
                    resetHandler={resetPurchases}
                >
                    <PurchaseFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default Purchase